import {apiV2} from './api';
import Department from 'records/Department';
import {List} from 'immutable';

function url(id) {
  return `/admin/department/${id}/profiles`;
}

export default {
  createDepartment(department) {
    return apiV2.postJson(`/admin/department`, department.toJS()).then(r => new Department(r));
  },
  updateDepartment(department) {
    return apiV2.putJson(url(department.id), department.toJS()).then(r => new Department(r));
  },
  deleteDepartment(department) {
    return apiV2.delete(`/admin/department/${department.id}`);
  },
  fetchDepartment(departmentId) {
    return apiV2.getJson(url(departmentId)).then(r => new Department(r));
  },
  fetchDepartmentProfiles(isAdmin = true) {
    if (isAdmin) {
      return apiV2.getJson('/admin/departments/ALL/profiles').then(({departments}) => {
        return List(departments.map(r => new Department(r)));
      });
    } else {
      return apiV2.getJson('departments_within_user_perms').then(({departments}) => {
        return List(departments.map(r => new Department(r)));
      });
    }
  },
  fetchUserDepartment() {
    return apiV2.getJson('department_for_user').then(r => new Department(r));
  },
};
